import React, { useEffect, useState } from "react";
import "./Description.css";
import { changingTabsWithCustomButton } from "../../../../Redux/actions/Dashboard/Dashboard";
import { resetSrfSearchData } from "../../../../Redux/actions/Srf/Srf";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import GreenTag from "../../../../images/green-tag.png";
import PurpleTag from "../../../../images/purple-tag.png";
const Description = ({
  sockId,
  sockName,
  vendor,
  color,
  size,
  promisedExFactory,
  brand,
  season,
}) => {
  const [reqExFactoryDate, setReqExFactoryDate] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (
      promisedExFactory?.request_details &&
      Array.isArray(promisedExFactory?.request_details)
    ) {
      promisedExFactory?.request_details?.map((data, index) => {
        setReqExFactoryDate(data?.req_exfactory);
      });
    }
  }, [promisedExFactory]);
  const onParentStyleClicked = () => {
    localStorage.setItem(
      "DashboardData",
      JSON.stringify({
        style: sockId,
        factory: vendor,
        season: season,
        brand: brand,
      })
    );
    localStorage.removeItem("srtMassData");
    localStorage.removeItem("massFilterData");
    dispatch(resetSrfSearchData([]));
    localStorage.setItem("RequestSend", false);
    dispatch(changingTabsWithCustomButton("true.2"));
    localStorage.removeItem("SrfSearchData");
    navigate("/sample-request-form");
  };
  return (
    <div className="description-wrapper">
      <p className="description-title">Style Description</p>
      <p className="common-font">{sockName}</p>
    </div>

  );
};

export default Description;
